<template>
    <div>
        <a-modal :visible="isShow" width="700px" title="拆包提示" :footer="null" @cancel="cancel" centered class="package_modal">
            <div class="content">
                <p>{{`当前商品预估总重量为${weight}kg，建议拆为${packageNum}个包，快递费可优惠${discountFreight}元。`}}</p>
                <p class="mt10">是否拆包？</p>
            </div>
            <div class="btn_confirm">
                <a-button type="primary" @click="ok">确认拆包</a-button>
                <a-button @click="cancel" class="ml20">不用，谢谢</a-button>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'PackageModal',
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
            type: Boolean,
        },
        curFreight: {
            type: String | Number,
            require: true
        },
        splitPackageFreight: {
            type: String | Number,
            require: true
        },
        packageList: {
            type: Array,
            required: true
        },
        weight: {
            type: String | Number,
            require: true
        }
    },
    computed: {
        discountFreight () {
            return Number(this.curFreight) - Number(this.splitPackageFreight)
        },
        packageNum () {
            return this.packageList.length
        }
    },
    methods: {
        ok () {
            this.$emit('splitPackage', true)
            this.$emit('hidden', false)
        },
        cancel () {
            this.$emit('splitPackage',false)
            this.$emit('hidden', false)
        },
    },
}
</script>

<style scoped>
.package_modal {
    color: #333333;
}

.package_modal >>> .ant-modal-header {
    border-top: 5px solid #fd5902;
    text-align: center;
}

.package_modal .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.btn_confirm {
    text-align: center;
    margin-top: 20px;
}

.btn_confirm >>> .ant-btn {
    height: 35px;
    width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/order/PackageModal.vue